<div *ngIf="distributor === null" class="alert alert-secondary m-2" role="alert">{{'distributor.select_distributor_alert' | translate}}</div>
<div *ngIf="distributor !== null">
  <div>
    <lib-prod-header [title]="" [icon]="'info_outline'" [class]="'distributor-upper'">
      <app-distributor-detail [distributorId]="distributor.id"></app-distributor-detail>
    </lib-prod-header>
  </div>
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label><i class="material-icons">groups</i>&nbsp;Groups</ng-template>
      <ng-template matTabContent>
        <app-distributor-group [distributor]="distributor.id"></app-distributor-group>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><i class="material-icons">groups</i>&nbsp;Users</ng-template>
      <ng-template matTabContent>
        <app-distributor-user [distributor]="distributor.id"></app-distributor-user>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
